import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from '../../common/popups/confirmation-popup/confirmation-popup.component';
import { confirmationMessages } from 'src/app/utils/popup-messages';
import { AssignBusinessPopupComponent } from '../../common/assign-business-popup/assign-business-popup.component';
import { CommonDataSharingService } from '../../services/common-data-sharing.service';
import { ChangePasswordComponent } from '../../common/change-password/change-password.component';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public isCollapsed = true;
  userDetails: any;
  assignedBusinessesCount: any = [];
  notificationLists: any = [];
  notificationCount: any;
  totalUnreadCount: any;
  selectedTab: any = 0;

  constructor(private _ngbModal: NgbModal, private _auth: AuthService, private _commonDataService: CommonDataSharingService) {
    this._commonDataService.getAssignedBusinessesList().subscribe({
      next: (res: any) => this.assignedBusinessesCount = res.length
    });
    this._commonDataService.notificationHeader.subscribe(notificationId => {
      if (notificationId) {
        for (let i = 0; i < this.notificationLists.length; i++) {
          if (notificationId === this.notificationLists[i].id) {
            this.notificationLists[i].showApproveEditRequest = 0;
          }
        }
      }
    });
    this._commonDataService.notificationIsRead.subscribe(notificationId => {
      if (notificationId) {
        for (let i = 0; i < this.notificationLists.length; i++) {
          if (notificationId === this.notificationLists[i].id) {
            this.notificationLists[i].isRead = 1;
          }
        }
      }
    });
    this._commonDataService.notificationMarkAllRead.subscribe(val => {
      if (val) { this.makeReadAll(); }
    });
    this._commonDataService.notificationSidebarToHeader.subscribe(res => {
      if (res) { 
        this.notificationCount = res.data.data.count;
        this.notificationLists = res.data.data.rows;
        this.totalUnreadCount = res.data.totalUnreadCount
      }
    });
  }

  ngOnInit(): void {
    this.getProfile();
    this.getNotification();
  }

  onSignOut(): void {
    let modalRef = this._ngbModal.open(ConfirmationPopupComponent, { backdrop: 'static', keyboard: false, size: "small confirmationPopup" });
    modalRef.componentInstance.confirmationMessage = confirmationMessages.logout;
    modalRef.result.then((res: any) => {
      if (res) {
        this._auth.signOut();
      }
    })
  }

  private getProfile(): void {
    this._auth.getUserProfile().subscribe({
      next: (res: any) => {
        this.userDetails = res.data;
        this._auth.setNavigateData(this.userDetails)
      }, error: (err: any) => {

      }
    })
  }

  private getNotification(): void {
    this._commonDataService._getToggleNotification(this.selectedTab).subscribe({
      next: (res: any) => {
        this.notificationCount = res.data.data.count;
        this.notificationLists = res.data.data.rows;
        this.totalUnreadCount = res.data.totalUnreadCount
      }, error: (err: any) => {
        console.log(err);
      }
    })
  }

  changeTab(val: any) {
    this.selectedTab = val;
    this.getNotification();
  }

  markAllAsRead() {
    this._commonDataService._markAllAsRead().subscribe({
      next: (res: any) => {
        this.makeReadAll();
        this._commonDataService.notificationMarkAllRead.next(true);
      }, error: (err: any) => {
        console.log(err);
      }
    })
  }

  private makeReadAll(): void {
    this.totalUnreadCount = 0;
    this.notificationLists.map((obj: any) => { obj.isRead = 1; });
  }

  toggleSidebar() {
    document.querySelector('body')?.classList.toggle('sidenav-toggled');
  }

  toggleSidebarNotification() {

  }

  toggleSwitcher() {

  }

  openBusinessList(): void {
    const businessPopup = this._ngbModal.open(AssignBusinessPopupComponent, { size: 'lg', centered: true });
    businessPopup.result.then((result: any) => {
      if (result) {

      }
    })


  }

  changePassword(): void {
    const updatePwdPopup = this._ngbModal.open(ChangePasswordComponent, { size: 'small', centered: true });
    updatePwdPopup.result.then((result: any) => {
      if (result) {

      }
    })
  }
}
